var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import { useQuery, useMutation } from 'libs/react';
import { DropdownButton } from 'components/DropdownButton';
import { RefusalReasonsQuery } from 'graphql/RefusalReason/queries/RefusalReasonsQuery';
import { useAlert } from 'components/alert/AlertStack';
import { UpdateDealMutation } from 'graphql/Deal/mutations/UpdateDealMutation';
/**
 * @component RefusalReasonSelect
 * Displays a dropdown to assign a refusal reason to a deal.
 * Saves immediately on change via UpdateDealMutation.
 * @since 1.0.0
 */
export function RefusalReasonSelect(props) {
    var _a;
    const { dealId, value, disabled, refetchQueries } = props;
    const alert = useAlert();
    const [data] = useQuery(RefusalReasonsQuery, {
        variables: { input: {} }
    });
    const [updateDeal] = useMutation(UpdateDealMutation);
    const [options, setOptions] = useState([]);
    const loadedReasons = (_a = data === null || data === void 0 ? void 0 : data.refusalReasons) !== null && _a !== void 0 ? _a : [];
    useEffect(() => {
        setOptions([
            { value: '', label: t('— None —') },
            ...loadedReasons.map((r) => ({ value: r.id, label: r.title }))
        ]);
    }, [data]);
    function onSelect(reasonId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield updateDeal({
                    variables: {
                        input: {
                            id: dealId,
                            newVersion: false,
                            refusalReasonId: reasonId || null
                        }
                    },
                    refetchQueries
                });
            }
            catch (error) {
                alert.present({ error });
            }
        });
    }
    return (React.createElement(DropdownButton, { style: "normal", size: "small", options: options, value: value !== null && value !== void 0 ? value : '', onSelect: onSelect, disabled: disabled, placeholder: t('Refusal Reason') }));
}
